module.exports = __webpack_public_path__ + "img/DomainOutlined.4a809fa0.svg";